// extracted by mini-css-extract-plugin
module.exports = {"loader":"loader_loader__QSgID","rotation1":"loader_rotation1__KNHFq","rotation2":"loader_rotation2__fl6o2"};